module.exports = __webpack_public_path__ + "static/media/jiqix.77d9943f.png";